var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('chief-dept-rating-navigation-drawer',{attrs:{"drawer":_vm.drawerApp}}),_c('toolbar',{attrs:{"is-lang-switcher":false,"color":"orange darken-3"},on:{"toggleDrawer":function($event){_vm.drawerApp = !_vm.drawerApp}}}),_c('v-main',[_c('router-view',{key:_vm.$route.fullPath})],1),_c('snack-displayer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }